export const promptHubDefaultPromptId = 'add4bd0e-c548-4390-96d3-7b53e463148b'
export const experimentalTemplatePromptId = 'df8b5627-d01d-445f-8c93-9d38caf933fb'
export const promptHubTonePromptId = '05c03968-bc79-44cd-bfae-46985edc72f6'

export const fileInfoDomain = 'https://files.wix.com/site/media/files'
export const infoPath = 'info'

export const promptHubBusinessNameShorterPromptId = 'aaf4e2f5-a3a6-45b7-9d88-e763e3164d57'
export const promptHubStructurePromptId = '69f7ce91-4309-40ca-b09e-322a495adca2'
export const promptHubNewOutlineStructurePromptId = 'cbd2813b-a271-4c95-8e6c-9ec1c63e926c'
export const promptHubFlatStructurePromptId = '5654e211-0a21-4994-a47d-cb373d1ead73'
export const promptHubFlatStructureWithLangPromptId = '26049616-2409-4132-9f19-cd70753a4a9b'
export const promptHubCharCountPromptId = '129e7801-108a-4b46-862c-f3c1cbb7bfa9'
export const promptHubCharCountExpPromptId = 'a5d99d78-b8f6-4e07-8aca-1acdd9d33964'

export const promptHubLinkGenerationPromptId = '416c27aa-c37c-41a0-9e1c-049329707391'
export const promptHubNewBuilderOutlineDataPromptId = '0144f9fa-f9e5-4f09-b2b0-8f8e3921e3b0'

export const nonApplicableParamsVersion = 'N/A'

export const aiGatewayUrl = '/_serverless/ai-gateway/ai-prompt'
export const promptHubAppId = 'c4de5ff8-cb71-476c-9208-5dbfca312c15'

export const aiContentOutlineResultErrorType = 'invalidAIContentOutline'
export const aiContentOutlineResultErrorMessage = 'AI Outline result is invalid or does not match the page structure'
export const aiContentOutlineResultConsecutiveErrorType = 'InvalidAIContentOutlineConsecutive'
export const aiContentOutlineResultConsecutiveErrorMessage =
    'AI Outline result is invalid or does not match the page structure also after a retry'
export const aiRequestErrorType = 'AIOutlineContentRequestError'
export const aiRequestErrorMessage = 'AI Content request failed'
export const aiContentTooLongErrorType = 'AIOutlineContentTooLongError'
export const aiContentTooLongErrorMessage = 'Some of the returned content is too long relative to the original content'
export const aiContentBadJsonErrorType = 'AIOutlineContentBadJsonError'
export const aiContentBadJsonErrorMessage = 'AI Content returned unparsable JSON'
export const aiContentUnexpectedError = 'AIOutlineContentUnexpectedError'
export const aiContentUnexpectedErrorMessage = 'An unexpected error occurred while generating AI content'

export const aiVideoGeneratorServerlessUrl = '/_api/dm-server-image-injection/generate-videos'
export const aiSvgGeneratorServerlessUrl = '/_api/dm-server-image-injection/generate-svgs'
export const aiFileUploadServerlessUrl = '/_api/dm-server-image-injection/upload-file'
export const aiFilesUploadServerlessUrl = '/_api/dm-server-image-injection/upload-files'
export const aiFilesUploadSyncServerlessUrl = '/_api/dm-server-image-injection/upload-files-sync'

export const generationTimeBudget = 200000
export const aiImageDescriptorUrl = '/_api/wix-privatemedia-proxy-server/v1/files/get-file-by-id'
export const aiImageGeneratorServerlessUrl = '/_api/dm-server-image-injection/generate-images-with-hints'
export const aiImageGeneratorForSiteCreationServerlessUrl =
    '/_api/dm-server-image-injection/generate-images-with-hints-sc'

export const getSimilarImageServerlessUrlWorkflow = '/_api/dm-server-image-injection/generate-similar-images-workflow'
export const getMatchingImageServerlessUrl = '/_api/dm-server-image-injection/match-images-to-page'
export const getMatchingImageServerlessUrlWorkflow = '/_api/dm-server-image-injection/match-images-to-page-workflow'
export const getFittingImageServerlessUrlWorkflow = '/_api/dm-server-image-injection/fit-images-to-frame-workflow'
export const getImageWithNoBackgroundServerlessUrlWorkflow =
    '/_api/dm-server-image-injection/remove-images-background-workflow'
export const getEditedImageServerlessUrlWorkflow = '/_api/dm-server-image-injection/edit-images-workflow'
export const getUpscaledImageServerlessUrlWorkflow = '/_api/dm-server-image-injection/upscale-images-workflow'
export const getEnhancedImageServerlessUrlWorkflow = '/_api/dm-server-image-injection/enhance-images-workflow'
export const getLogoMediaObjectServerlessUrl = '/_api/dm-server-image-injection/generate-logo'
export const getLogoImagesServerlessUrlWorkFlow = '/_api/dm-server-image-injection/edit-logos'

export const aiContentMainPageFailedErrorType = 'AIContentMainPageFailedError'
export const aiContentMainPageFailedErrorMessage = 'AI Content failed to generate content for main page'
export const aiContentAllPagesFailedErrorType = 'AIContentAllPagesFailedError'

export const aiContentMissingOnOutlineErrorType = 'AIContentMissingOnOutlineError'
export const aiContentMissingOnOutlineMessage = 'Ai content failed for specific field'
export const aiContentAllPagesFailedErrorMessage =
    'AI Content site suggestion failed for all pages and main page was ignored'
export const aiBusinessNameFieldIdMissingType = 'BusinessNameFieldIdMissing'
export const aiBusinessNameFieldIdMissingMessage = 'BusinessNameFieldId is Missing'

export const aiBusinessNamePathMissingOnObjectType = 'BusinessNamePathIsWrong'
export const aiBusinessNamePathMissingOnObjectMessage = 'BusinessName path is Wrong'
export const aiShorterBusinessNameRequestErrorType = 'AiShorterBusinessNameRequestError'
export const aiShorterBusinessNameRequestErrorMessage = 'AI Content request for shorter business name failed'
export const aiPageSuggestionInteraction = 'ai-content-page-suggestion'
export const aiMultiChoiceCompletionInteraction = 'ai-content-multi-choice-completion'
export const aiLinkGenerationRequestErrorType = 'AiLinkGenerationNameRequestError'
export const aiLinkGenerationRequestErrorMessage = 'AI Content request for link generation failed'
export const aiBuilderInjectionErrorType = 'AiBuilderInjectionError'
export const aiBuilderInjectionErrorMessage = 'AI Content request for new builder injection failed'
export const aiLinkGenerationResultConsecutiveErrorType = 'InvalidLinkGenerationOutlineConsecutive'
export const aiLinkGenerationResultConsecutiveErrorMessage =
    'AI Outline result is invalid or does not match the link generation formant also after a retry'
export const aiBuilderInjectionResultConsecutiveErrorType = 'InvalidBuilderInjectionConsecutive'
export const aiBuilderInjectionResultConsecutiveErrorMessage =
    'AI Builder injection result is invalid or does not match the Builder injection format also after a retry'

export const aiLinkGenerationInteraction = 'ai-link-generation-suggestion'
export const aiLinkGenerationInteractionGetPageOutline = 'ai-link-generation-suggestion-get-page-outline'
export const aiLinkGenerationInteractionFetchLinks = 'ai-link-generation-suggestion-fetch-links'
export const aiLinkGenerationInteractionGenerateLinksDataItems =
    'ai-link-generation-suggestion-generate-links-data-item'
export const blacklistedContentPhrases = [
    "i'm a paragraph",
    'im a paragraph',
    'click here to add your own text and edit me',
    "i'm a great place for you to tell a story and let your users know a little more about you",
    'a great place for you to tell a story and let your users know a little more about you'
].map(phrase => phrase.toLowerCase())

export const blacklistedPageTitleKeywords = ['policy']

export const aiRequestErrorOutlineValidationFailedTag = 'outline-fields-mismatch'
export const aiRequestErrorBlacklistValidationFailedTag = 'blacklist-threshold-exceeded'

export const shortenBusinessNameInteraction = 'shorten-business-name-interaction'

export const aiStructureMissingOutlineMessage = 'AI Content section suggestion failed - empty outline response'

export const multichoiceLanguage = 'english'

export const proactiveAiBuildSiteContextPromptId = 'b5275669-4e61-4586-b0d2-d62bce5bf5d9'
export const proactiveAiAnalysisPromptId = 'c7f8c0aa-1d74-4010-8dbf-2fa04674004d'
export const proactiveAiRecommendationPromptId = '24822143-d131-4e54-a9a1-34acf84bec97'

export const proactiveAiAnalyzeErrorType = 'ProactiveAiAnalyzeError'
export const proactiveAiAnalyzeErrorMessage = 'Failed to analyze content with Proactive AI'
export const proactiveAiAnalyzeBadJsonErrorType = 'ProactiveAiAnalyzeBadJsonError'
export const proactiveAiAnalyzeBadJsonErrorMessage = 'Proactive AI analyze returned unparsable JSON'

export const proactiveAiRecommendErrorType = 'ProactiveAiRecommendError'
export const proactiveAiRecommendErrorMessage = 'Failed to generate recommendations with Proactive AI'
export const proactiveAiRecommendBadJsonErrorType = 'ProactiveAiRecommendBadJsonError'
export const proactiveAiRecommendBadJsonErrorMessage = 'Proactive AI recommend returned unparsable JSON'

export const uploadTimeoutReason = 'Timeout'

export const LOGS = {
    FILES: {
        UPLOAD: 'FILES_UPLOAD'
    },

    IMAGES: {
        GENERATION: 'IMAGES_GENERATION',
        UPLOAD: 'IMAGES_UPLOAD',
        WORKFLOW: 'IMAGES_WORKFLOW_GENERATION'
    },
    VIDEO: {
        GENERATION: 'VIDEO_GENERATION',
        UPLOAD: 'VIDEO_UPLOAD'
    },
    SVGS: {
        GENERATION: 'SVGS_GENERATION',
        UPLOAD: 'SVGS_UPLOAD'
    },
    LOGOS: {
        GENERATION: 'LOGOS_GENERATION',
        UPLOAD: 'LOGOS_UPLOAD',
        WORKFLOW: 'LOGOS_WORKFLOW_GENERATION'
    }
}

export const ERRORS = {
    IMAGES: {
        GENERATION: 'ImagesGenerationError',
        GENERATION_VALIDATION_ERROR: 'ImagesGenerationValidationError',
        UPLOAD: 'ImagesUploadError',
        GENERATION_NO_IMAGES_WITH_HINTS: 'NoImagesFoundError',
        EDIT_IMAGES: 'EditImagesError',
        ENHANCE_IMAGES: 'EnhanceImagesError',
        FIT_IMAGES_TO_FRAME: 'FitImagesToFrameError',
        GENERATE_SIMILAR_IMAGES: 'GenerateSimilarImagesError',
        MATCH_IMAGES_TO_PAGE: 'MatchImagesToPageError',
        REMOVE_IMAGES_BACKGROUND: 'RemoveImagesBackgroundError',
        UPSCALE_IMAGES: 'UpscaleImagesError'
    },
    BUILDER: {
        NOT_BUILDER_COMPONENT: 'NotBuilderComponent'
    },
    VIDEO: {
        GENERATION: 'VideoGenerationError',
        UPLOAD: 'VideoUploadError'
    },
    SVGS: {
        GENERATION: 'SvgsGenerationError',
        UPLOAD: 'SvgsUploadError'
    },
    LOGOS: {
        GENERATION: 'LogosGenerationError',
        GENERATION_VALIDATION_ERROR: 'LogosGenerationValidationError',
        EDIT_LOGOS: 'EditLogosError'
    }
}
